import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'timeFormat'
})
export class TimeFormatPipe implements PipeTransform {
	transform(value: number, type: 'duration' | 'countdown' = 'duration'): string {
		if (value === null || value === undefined || value < 0) {
			return '';
		}

		const hours: number = Math.floor((value % 86400) / 3600);
		const minutes: number = Math.floor((value % 3600) / 60);
		const seconds: number = Math.ceil(value % 60);

		if (type === 'duration') {
			const minutesString: string = minutes.toFixed(0).toString();
			const secondsString: string = seconds > 0 ? seconds.toFixed(0).toString() + 's' : '';

			if (hours > 0) {
				const hoursString: string = hours.toFixed(0).toString();
				return `${hoursString}h ${minutesString}m${seconds > 0 ? ' ' + secondsString : ''}`;
			} else if (minutes > 0) {
				return `${minutesString}m${seconds > 0 ? ' ' + secondsString : ''}`;
			} else {
				return secondsString;
			}
		}

		if (type === 'countdown') {
			const hoursString: string = hours > 0 ? hours.toString() : '0';
			const minutesString: string = hours > 0 || minutes > 0 ? minutes.toString().padStart(2, '0') : '0';
			const secondsString: string = seconds.toString().padStart(2, '0');

			if (hours > 0) {
				return `${hoursString}:${minutesString}:${secondsString}`;
			} else if (minutes > 0) {
				return `${minutesString}:${secondsString}`;
			} else {
				return `${hoursString}:${secondsString}`;
			}
		}

		return '';
	}

}
